import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  id: string;
}
export const useSendOneLv = () => {
  const queryClient = useQueryClient();

  const mutationFn = async ({ id }: HookProps) => {
    await request({
      path: `idms/send-one-declaration`,
      method: 'POST',
      authenticate: true,
      dataObject: {
        declarationId: id,
      },
    });
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declarations'] });
      queryClient.invalidateQueries({ queryKey: ['declaration-groups'] });
      toast.success('Declaration sent successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error sending declaration!`);
    },
  });
};
